import { Component } from '@angular/core';
import { LoaderService } from './services/LoaderService/loader.service';
import { SharedService } from './services/SharedService/sharedService';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private sharedService: SharedService,
    private cookieService: CookieService,
  ) { }
  title = 'surveyor-panel';
  loader$ = this.loaderService.loader$
  LoginDetails: any;
  loggedIn: boolean = false;

  ngOnInit(){
    this.sharedService.userDetailsSubject$.subscribe((userDetails) => {
      let nextLoginDetails = userDetails;

      const validationKey = this.cookieService.get('ValidationKey');
      if (!validationKey && Object.keys(nextLoginDetails).length > 0) {
        this.sharedService.clearUserSession();
        nextLoginDetails = {};
      }

      this.LoginDetails = nextLoginDetails;

      if (Object.keys(this.LoginDetails).length > 0) {
        this.loggedIn = true;
      } else {
        this.loggedIn = false;
        if (!window.location.href.includes('feedback') && !window.location.href.includes('dynamic-forms')) {
          void this.router.navigate(['/login']);
        }
      }
    });
  }
  ngOnChanges(){
    if(Object.keys(this.LoginDetails).length > 0){
      this.loggedIn = true;
    }else{
      this.loggedIn = false;
      if(!window.location.href.includes('feedback') && !window.location.href.includes('dynamic-forms')){
        this.router.navigate(['/login'])
      }
    }

  }
}
